import { tokens } from "@blurb/codex-react";
import { createStyles } from "@mantine/core";

// quick-fix for the background color of outline buttons, should be removed after this is changed in codex
export const useButtonStyle = createStyles({ outlineButton: { background: tokens.color.semantic.bg.neutral } });
